import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";

interface SompoDeadlineAlertProps {
    diffDays: number | undefined;
    nearDeadline: boolean;
}

const SompoDeadlineAlert = (props: SompoDeadlineAlertProps) => (
    <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        sx={{
            visibility: props.nearDeadline ? "visible" : "hidden",
            width: "5.5em",
            bgcolor: "#FFA800",
            px: 0.5,
            borderRadius: "1rem",
            my: 0.5,
            color: "white",
            fontSize: "0.8rem",
            minHeight: "1.3rem",
        }}
    >
        {/** 期限アラート eラーニング、残り0~7日の時のみ表示 */}
        {props.nearDeadline && (
            <>
                <AlarmOnIcon sx={{ fontSize: "1em", mr: "2px" }} />
                <Typography sx={{ fontWeight: "bold" }}>{`残り${props.diffDays}日`}</Typography>
            </>
        )}
    </Grid>
);

export default SompoDeadlineAlert;
